import { Box, Spinner, Link, chakra } from "@chakra-ui/react";
import useTokenPrice from "../hooks/useTokenPrice";

const TokenPrice = () => {
	const { data, loading, error } = useTokenPrice();

	if (data == null || error) return;

	return (
		<Box>
			{loading ? (
				<Spinner size="lg" />
			) : (
				<Link pointerEvents="none"
					textDecoration="none">
					SCR Price: <chakra.span color={"#FF684B"}>${parseFloat(data.price).toFixed(3)}</chakra.span>
				</Link>
			)
			}
		</Box >
	);
};

export default TokenPrice;
